/** CoStar.Api.AptsBackOffice.ViewModels.Common.HealthStatusType */
export var HealthStatusType;
(function (HealthStatusType) {
    HealthStatusType[HealthStatusType["Normal"] = 0] = "Normal";
    HealthStatusType[HealthStatusType["Alert"] = 1] = "Alert";
    HealthStatusType[HealthStatusType["Error"] = 2] = "Error";
})(HealthStatusType || (HealthStatusType = {}));
